import { ReactNode } from 'react';
import styled from 'styled-components';
import { body2 } from 'ui/theme';
import { DataSet } from './types';
import { ModalSize } from './Modal.constants';
import { MODAL_BODY_STYLES } from './Modal.styled';
import { useModalContext } from './ModalContext';

const ModalBodyWrapper = styled.div<{ size?: ModalSize }>`
  ${body2};
  overflow-y: auto;
  overflow-wrap: anywhere;
  ${({ size }) => (size && MODAL_BODY_STYLES[size]) || ``};
`;

export type ModalBodyProps = {
  /* Body content (can be components) */
  children: ReactNode;
  /** Modal id */
  id?: string;
  /** Allows for optional override of size */
  size?: ModalSize;
};

export const ModalBody = ({ children, size: sizeProp, ...props }: ModalBodyProps) => {
  const { size: sizeContext } = useModalContext();
  const size = sizeProp ?? sizeContext;
  return (
    <ModalBodyWrapper
      size={size}
      onClick={(e) => e.stopPropagation()}
      data-test={DataSet.ModalBodyTestId}
      {...props}
    >
      {children}
    </ModalBodyWrapper>
  );
};
